export default "__VITE_ASSET__D5gvYew8__"